<template>
  <div style="text-align:center" id="main">
    <div class="payTop">
      <img class="logo"
        src="https://uploads-ssl.webflow.com/63377a4edcea6933891249a2/63377d0fd67f06ef48eef306_MORIEL%20ENGLISH%20LOGO.svg"
        width="100px" />
      <div class="backBtn" @click="navigate('chapter')">
        <inline-svg class="backs-svg" :src="require(`../../assets/svg/arrow-${ltr ? 'next' : 'back'}.svg`).default"></inline-svg>
        <span>{{ $t("user.payment.back") }}</span>
      </div>
    </div>
    <div class="title-wrapper">
      <h2>{{ $t("user.payment.pay") }}</h2>
    </div>
    <h2 v-if="loading && !message" class="loader">{{ $t("user.payment.approve") }}</h2>
    <h4 class="message" v-show="message">{{ message }}</h4>
    <div class="pay-result-message" v-if="paid_success">
      <button @click="navigate('chapter/')" class="payBtn">{{ $t("user.payment.back2") }}</button>
    </div>
    <div class="pay-result-message" v-else-if="paid_failed">
      <button @click="navigate('registration')" class="payBtn">{{ $t("user.payment.again") }}</button>
    </div>
    <div v-else>
      <div class="payment-details">
        <div class="pay-title" :style="{ textAlign: ltr ? 'left' : 'right' }" v-if="payment_option">{{ $t("user.payment.details") }}</div>
        <table class="table-basic" v-if="payment_option">
          <tbody class="service-price">
            <tr>
              <td>
                <span>{{ payment_option.text || "" }}</span> -
                <span class="ltr">₪{{ payment_option.price }}</span>
              </td>
            </tr>
          </tbody>
          <tfoot class="tfoot-basic">
            <tr>
              <td colspan="2" class="tfoot-basic">
                <div class="total">
                  <span>{{ $t("user.payment.sum") }} -</span>
                  <span dir="ltr" style="padding: 0px 0.3em">{{ Math.trunc(payment_option.price) }}₪</span>
                </div>
              </td>
            </tr>
          </tfoot>
        </table>
        <div class="subscription-loading" v-else>
          {{ $t("user.payment.loading") }}
        </div>
      </div>
      <div v-if="!loading && payment_option" class="pay-title form-title" :style="{ textAlign: ltr ? 'left' : 'right' }">{{ $t("user.payment.method") }}</div>
      <form v-if="!loading && payment_option" data-og="form" @submit.prevent="getFormValues" action="">
        <div class="og-errors"></div>
        <div class="cc-pay">
          <v-text-field class="payment-input" required :label="$t('user.payment.card-num')" data-og="cardnumber"
           autocomplete="cc-number" mask="####-####-####-####" color="blue"></v-text-field>
        </div>
        <div>
          <label>
            <div class="input-group-label" :style="{ textAlign: ltr ? 'left' : 'right' }" >{{ $t("user.payment.validity") }}</div>
            <div class="tokef">
              <v-text-field required :label="$t('user.payment.year')" data-og="expirationyear" type="number" class="cvv payment-input"
                mask="####" color="blue"></v-text-field>
              <div class="dateSeperator"> / </div>

              <v-text-field required :label="$t('user.payment.month')" data-og="expirationmonth" type="number" class="monthField payment-input"
                mask="##" color="blue" width=""></v-text-field>
            </div>
          </label>
        </div>


        <div>
          <v-text-field required :label="$t('user.payment.cvc')" data-og="cvv" type="number" class="cvv" mask="###"
            color="blue"></v-text-field>
        </div>
        <div>
          <v-text-field required :label="$t('user.payment.id')" data-og="citizenid" mask="#########"
            color="blue" type="number"></v-text-field>
        </div>
        <input type="hidden" :value="payment_id" name="payment_option_id" id="payment_option_id" />

        <input class="payBtn" :disabled="!payment_id" type="submit" :value="$t('user.payment.purchase')" />
        <div style="font-size:12px">
          {{ $t("user.payment.msg1") }}
        </div>
      </form>
    </div>
    <div class="footerLinks">
      <span class="fLink" @click="goToWA">{{ $t("user.payment.recovery") }}</span>
      <span class="fLink" @click="navigate('privacy')">{{ $t("user.payment.policy") }}</span>
      <span class="fLink" @click="navigate('terms')">{{ $t("user.payment.use_terms") }}</span>
    </div>
    <div class="layout-external-footer layout-external-footer-narrow">
      <div class="layout-external-footer-company">
        <div>{{ $t("user.payment.msg2") }}</div>
        <div v-html="$t('user.payment.msg3')">
        </div>
        <div style="text-align: center;">
          <img src="../../assets/img/payment_logos.svg" />
        </div>
      </div>
      <div class="layout-external-footer-security">
        <a target="_blank" class="no-smoothstate" href="https://www.myofficeguy.com"><img width="100px"
            class="using-tooltip" alt="התשלום מאובטח על ידי OfficeGuy, שירותים מקיפים לעסקים וארגונים חברתיים."
            src="https://www.myofficeguy.com/content/images/logo_full.png" /></a>
      </div>
    </div>
  </div>
</template>

<script>
import "./Payment.scss";
import { userService } from "../../services/userService";
export default {
  name: "payment",
  data() {
    return {
      path: null,
      client: null,
      payment_id: null,
      message: null,
      events: {},
      payRes: null,
      paid_success: false,
      paid_failed: false,
      notAgain: false,
      ltr: localStorage.getItem("srcDirection") == "ltr",

      value: 0
    };
  },
  created() {
    // window.addEventListener("message", result => {
    //   console.log(result);
    // });
  },
  mounted() {
    this.path = this.$route.path;
    this.payment_id = this.$route.params.id;
    console.log(this.$route.query);
    let officeguyScript = document.createElement("script");
    officeguyScript.setAttribute(
      "src",
      "https://app.sumit.co.il/scripts/payments.js"
    );
    document.head.appendChild(officeguyScript);
    let jquery = document.createElement("script");
    jquery.setAttribute("src", "https://code.jquery.com/jquery-3.6.3.min.js");
    document.head.appendChild(jquery);
    setTimeout(() => this.doThis(), 3000);
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    payment_options() {
      return this.$store.getters.payment_options;
    },
    payment_option() {
      if (this.payment_options) {
        return this.payment_options.find(res => res.id == this.payment_id);
      }
    },
    name() {
      if (this.user) {
        return this.user.first_name + " " + this.user.last_name;
      }
    },
    email() {
      if (this.user) {
        return this.user.email;
      }
    },
    loading() {
      if (this.$route.query["og-token"]) {
        return true;
      }
      return false;
    }
  },
  watch: {
    async user() {
      if (this.$route.query["og-token"] && !this.notAgain) {
        console.log("PAYYINGGG", this.notAgain);
        this.notAgain = true;
        this.payRes = await userService.pay(
          this.$route.query["payment_option_id"],
          this.$route.query["og-token"]
        );
      }
    },
    payRes() {
      console.log(this.payRes);

      if (this.payRes && this.payRes.status == "successful!") {
        this.message = this.$t("user.payment.success")
        this.paid_success = true;
        this.$router.replace({
          path: this.$route.path,
          query: {
            transactionId: this.payRes.data.transactionId,
            price: this.payRes.data.price,
            productName: this.payRes.data.productName
          }
        });
      } else if (
        this.payRes &&
        this.payRes.response &&
        (this.payRes.response.status >= 400)
      ) {
        this.message =
          this.payRes.response.data.UserErrorMessage ||
          this.payRes.response.data.TechnicalErrorDetails ||
          this.$t("user.payment.error")
        this.paid_failed = true;
      } else {
        this.message = this.$t("user.payment.contact")
        this.paid_failed = true;
      }
    }
  },
  methods: {
    doThis() {
      try {
        window.OfficeGuy.Payments.BindFormSubmit({
          CompanyID: process.env.VUE_APP_SUMIT_COMPANY_ID,
          APIPublicKey: process.env.VUE_APP_SUMIT_PUBLIC_KEY,
        });
      } catch (e) {
        console.log(e);
      }

      console.log("HERE");
    },
    doThat() {
      //   let a = window.OfficeGuy.Payments({
      //     CompanyID: "175778430",
      //     APIPublicKey: "8oIL1ksmRDuJWKYdS831ii3guv8Krt7La8QGaAZrRRS9xWSoCY"
      //   });
      //   let b = document.querySelector("form");
      //   console.log(a);
      //   console.log(b);
      window.OfficeGuy.Payments.CreateToken({
        CompanyID: process.env.VUE_APP_SUMIT_COMPANY_ID,
        APIPublicKey: process.env.VUE_APP_SUMIT_PUBLIC_KEY,
      });
    },
    navigate(path) {
      this.$router.push(`/${path}`);
    },
    goToWA() {
      //console.log("YO");
      window.open(
        "https://api.whatsapp.com/send?phone=972526252650&text=%D7%94%D7%99%D7%99!%20%F0%9F%98%83%0A%D7%90%D7%A0%D7%99%20%D7%A8%D7%9B%D7%A9%D7%AA%D7%99%20%D7%9E%D7%A0%D7%95%D7%99%20%D7%9C%D7%90%D7%A4%D7%9C%D7%99%D7%A7%D7%A6%D7%99%D7%94%20%D7%A9%D7%9C%D7%9A%20%D7%9B%D7%91%D7%A8%20%D7%95%D7%92%D7%9D%20%D7%99%D7%A9%20%D7%9C%D7%99%20%D7%A7%D7%91%D7%9C%D7%94%20%D7%90%D7%91%D7%9C%20%D7%96%D7%94%20%D7%93%D7%95%D7%A8%D7%A9%20%D7%9E%D7%9E%D7%A0%D7%99%20%D7%AA%D7%A9%D7%9C%D7%95%D7%9D%2C%20%D7%AA%D7%95%D7%9B%D7%9C%20%D7%9C%D7%A2%D7%96%D7%95%D7%A8%20%D7%9C%D7%99%20%D7%9C%D7%A9%D7%97%D7%96%D7%A8%20%D7%90%D7%AA%20%D7%94%D7%9E%D7%A0%D7%95%D7%99%20%D7%A9%D7%9C%D7%99%3F%0A%D7%AA%D7%95%D7%93%D7%94",
        "_blank"
      );
    },
    getFormValues(submitEvent) {
      console.log(submitEvent.target);
      submitEvent.preventDefault();
    }
  },
  components: {}
};
</script>



// WEBPACK FOOTER //
// Payment.vue?f9d52e98